const isVisibleOnlyOnDesktop = (isMobile) => ({
  resolve: () => !isMobile
});
export {
  isVisibleOnlyOnDesktop
};
//# sourceMappingURL=is-visible-only-on-desktop.js.map
